import { RaceProgressLapPenaltyRaw } from "./interfaces/race_progress_lap_penalty_raw.interface";

export class RaceProgressLapPenalty {
    time: Date;
    text: string;

    constructor(obj: RaceProgressLapPenaltyRaw) {
        //TODO проверить точно тут метка времени, а не кол-во миллисекунд
        this.time = new Date(obj.time);
        this.text = obj.text;
    }
}